<script setup>
import { defineProps, defineEmits } from "vue";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import Setup2FA from "@/components/Setup2FA.vue";
import { useScreenStore } from "@/store/useScreenStore";

defineProps({
  visible: Boolean,
});
const emit = defineEmits(["update:visible"]);

const screen = useScreenStore();
</script>

<template>
  <Dialog
    :visible="visible"
    @update:visible="(v) => emit('update:visible', v)"
    modal
    header="Seguridad"
    :style="{ width: screen.isMobile ? '100%' : '460px' }"
  >
    <Setup2FA />
    <template #footer>
      <Button label="Cerrar" text @click="emit('update:visible', false)" />
    </template>
  </Dialog>
</template>
